import { render, staticRenderFns } from "./Contenedor.vue?vue&type=template&id=6888d505&scoped=true&"
import script from "./Contenedor.vue?vue&type=script&lang=js&"
export * from "./Contenedor.vue?vue&type=script&lang=js&"
import style0 from "./Contenedor.vue?vue&type=style&index=0&id=6888d505&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6888d505",
  null
  
)

/* custom blocks */
import block0 from "./Contenedor.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports